const DistributedSEIR = (props) => {
    const content = {};

    content["ru"] =
        <>
        <p>
            Раздел "Карты эпидемий" веб-приложения "Медицинский атлас" позволяет визуализировать на карте динамику
            распространения эпидемий, используя встроенные математические модели, а также на основе загруженных
            пользователем фактических данных, собранных в ходе регистрации реальной эпидемии.
        </p>
        <p>
            <u>Классическая SEIR-модель</u> &ndash; одна из самых известных в эпидемиологии &ndash; содержит четыре переменные:
            <ul>
                <li><b>S (Susceptible)</b> &ndash; здоровые, при этом ранее не болевшие (восприимчивые)</li>
                <li><b>E (Exposed)</b> &ndash; больные, находящиеся в инкубационном периоде</li>
                <li><b>I (Infected)</b> &ndash; больные, распространяющие заболевание</li>
                <li><b>R (Recovered)</b> &ndash; здоровые, при этом ранее болевшие и уже выздоровевшие</li>
            </ul>
        </p>
        <p>
            Каждая из этих переменных отражает значение доли населения, относящейся к соответствующему состоянию.
            Их динамика описывается следующей системой дифференциальных уравнений:
        </p>
        <p>
            <center><img src="/Epidemics/SEIR_equations.svg" alt="" width={150} /></center>
        </p>
        <p>
            В качестве начальных значений переменных используются <b>E</b> = <b>R</b> = 0, а <b>S</b> и <b>I</b> берутся из того расчета, что
            один из жителей (нулевой пациент) является инфицированным (<b>I</b>), а все остальные &ndash; восприимчивыми (<b>S</b>).
            Коэффициенты <b>&beta;</b>, <b>&sigma;</b> и <b>&gamma;</b> выражают скорости инфицирования контактных лиц, перехода заболевания
            из инкубационного периода в фазу распространения и выздоровления, соответственно.
        </p>
        <p>
            Предложенная <u>распределенная SEIR-модель</u> отличается тем, что решение этой системы дифференциальных
            уравнений производится для каждого из жилых домов города в отдельности, при этом для перехода <b>S</b> &rarr; <b>E</b> при
            передаче инфекции учитывается популяция домов, расположенных в пределах радиуса инфицирования <b>r</b>,
            который является дополнительным параметром этой модели наряду с координатами домов и их населением.
        </p>
        <p>
            Полученные в результате моделирования по заданному городу данные отображаются в виде тепловой карты
            (шаги по 0.2 - синий, голубой, лаймовый, желтый, красный).
            Кнопка "Слои" позволяет выбрать переменную для просмотра ее динамики на карте города,
            а также суммарной динамики на представленном графике.
        </p>
        </>

    content["en"] = 
        <>
        <p>
            The "Epidemic maps" section of "Medical Atlas" web application visualizes epidemic spread process on the 
            geographical map using the built-in mathematical models as well as custom epidemic data uploaded by user and
            based on registration of the real epidemic.
        </p>
        <p>
            <u>The classic SEIR model</u>, being one of the most famous models in epidemiology, contains four variables:
            <ul>
                <li><b>S (Susceptible)</b> &ndash; healthy population who did not get sick before</li>
                <li><b>E (Exposed)</b> &ndash; sick people who are in incubation phase of disease</li>
                <li><b>I (Infected)</b> &ndash; sick people who are spreading the disease</li>
                <li><b>R (Recovered)</b> &ndash; healthy people who were sick and got recovered</li>
            </ul>
        </p>
        <p>
            Each of these variables reflect a fraction of population which belongs to the corresponding epidemic state.<br />
            Dynamics of variables are described by the following system of differential equations:
        </p>
        <p>
            <center><img src="/Epidemics/SEIR_equations.svg" alt="" width={150} /></center>
        </p>
        <p>
            As initial values of variables, the model assumes <b>E</b> = <b>R</b> = 0, while <b>S</b> and <b>I</b> values correspond to situation when one 
            person (patient zero) is already infected (<b>I</b>), and the rest of population belongs to susceptible group (<b>S</b>). The <b>&beta;</b>, <b>&sigma;</b>, <b>&gamma;</b>&nbsp;
            coefficients reflect rates of infection spread from infected to susceptible people, disease transition from incubation to 
            spreading phase, and recovery, respectively.
        </p>
        <p>
            The proposed <u>distributed SEIR model</u> is different from classic one in that solving the aforementioned system of 
            differential equations is performed for each of residential buildings separately, while for <b>S</b> &rarr; <b>E</b> transition during 
            infection spread it considers the population of buildings situated within radius of infection, which is taken as additional
            model parameters along with separate building coordinates and populations.
        </p>
        <p>
            The simulation data on the particular town set by user is visualized as an overlay heat map (steps of 0.2 - blue, cyan, lime, yellow, red). The "Layers" button allows 
            to select one of four variables to view its dynamics in the town, as well as summary dynamics displayed on the 
            traditional SEIR graph.
        </p>
        </>

        return content[props.language];
};

export { DistributedSEIR };